module.exports = require("core-js/library/fn/map");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/map.js
// module id = PHuJ
// module chunks = 0